/**
 * Every language Citylytics has a name for. Which of them a workspace speaks is its own choice
 * (each declares its list next to its locale files), since apps translate at different paces.
 */
export const LANGUAGE = {
    EN: 'en',
    SV: 'sv',
    DA: 'da',
};
export const LANGUAGES = [LANGUAGE.EN, LANGUAGE.SV, LANGUAGE.DA];
/** What anyone asking for a language their app or the API doesn't have gets instead. */
export const FALLBACK_LANGUAGE = LANGUAGE.EN;
/** Each language in its own language, so a speaker finds theirs whatever is showing; never translated. */
export const LANGUAGE_LABELS = {
    [LANGUAGE.EN]: 'English',
    [LANGUAGE.SV]: 'Svenska',
    [LANGUAGE.DA]: 'Dansk',
};
/** The one i18next namespace every workspace's locale files are loaded into. */
export const TRANSLATION_NAMESPACE = 'translation';
